import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails, IContractorAreaResponseDTO } from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class GetAreasByContractorIdCommand extends IRequestCommand<IGetAreasByContractorIdResponse, ErrorDetails, IGetAreasByContractorIdCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'contractorsAreas/{contractorUserId}';
    public override setParameters(parameters: IGetAreasByContractorIdCommandParameters) {
        if(parameters.exludeAreaId != null){
            this._commandUrl = this._commandUrl + "/exclude/{idAreaExclude}";
            this._commandUrl = this._commandUrl.replace('{idAreaExclude}', parameters.exludeAreaId.toString());
        }
        this._commandUrl = this._commandUrl.replace('{contractorUserId}', parameters.contractorUserId);
       
    };
}

export interface IGetAreasByContractorIdCommandParameters extends ICommandParameters {
    contractorUserId: string;
    exludeAreaId: number;
}

export interface IGetAreasByContractorIdResponse extends IContractorAreaResponseDTO, ICommandResponse {

}